import IconTrash1 from "@/icons/IconTrash1";
import React, { useCallback, useState } from "react";
import Option from "react-select/dist/declarations/src/components/Option";
import { ShopifyList, ShopifyMap } from "./ShopifyMappingTable";
import { debounce } from "@/utils/fn";

interface Option {
  value: any;
  label: string;
  key?: string;
  disabled?: boolean;
}

interface Props {
  mappedField: ShopifyMap;
  i: number;
  updateMappedField: (i: number, field: ShopifyMap) => void;
  metadata: Option[];
  isLoading: boolean;
  handleModal: (field: ShopifyMap) => void;
  fetchList: (fields: ShopifyMap[]) => void;
  listFields: ShopifyList[];
  deleteRow: (i: number) => void;
  saveRecord: () => void;
  showSavedMessage: () => void;
}

export default function ShopifyPanelRow(props: Props) {
  const handleChange = (callback: () => void) => {
    callback();
    props.showSavedMessage();
  };

  return (
    <tr key={props.i}>
      <td className="pb-4 pr-5 pl-4">
        <div className="relative text-slate-800 text-sm font-normal border border-slate-300 rounded-lg">
          <select
            className="w-full text-sm font-normal bg-white rounded-lg border-none px-4 py-2 appearance-none focus:outline-none focus:ring-0"
            value={props.mappedField.ShopifyField?.value || ""}
            onChange={(e) =>
              handleChange(() => {
                props.updateMappedField(props.i, {
                  ...props.mappedField,
                  ShopifyField: {
                    value: e.target.value,
                    label: e.target.options[e.target.selectedIndex].text
                  }
                });
              })
            }
            disabled={props.isLoading}
          >
            {props.isLoading ? (
              <option>Loading...</option>
            ) : (
              props.metadata.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))
            )}
          </select>
          <div className="absolute right-2 top-1/2 -translate-y-1/2 pointer-events-none flex items-center text-slate-400">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
        </div>
      </td>
      <td className="pb-4  ">
        <input
          className="w-full h-max focus:outline-none p-2 text-slate-800 text-sm font-normal border border-slate-300 rounded-lg"
          value={props.mappedField.defaultValue || ""}
          placeholder="Enter default value"
          onChange={(e) =>
            handleChange(() =>
              props.updateMappedField(props.i, {
                ...props.mappedField,
                defaultValue: e.currentTarget.value
              })
            )
          }
        ></input>
      </td>
      <td className="pb-4">
        <input
          type="checkbox"
          className="input w-full"
          checked={props.mappedField.create}
          onChange={() =>
            handleChange(() =>
              props.updateMappedField(props.i, {
                ...props.mappedField,
                create: !props.mappedField.create
              })
            )
          }
        ></input>
      </td>
      <td className="pb-4">
        <input
          type="checkbox"
          className="input w-full"
          checked={props.mappedField.usedForSearching}
          onChange={() =>
            handleChange(() =>
              props.updateMappedField(props.i, {
                ...props.mappedField,
                usedForSearching: !props.mappedField.usedForSearching
              })
            )
          }
        ></input>
      </td>
      <td className="pb-4">
        <input
          type="checkbox"
          className="input w-full"
          checked={props.mappedField.showWhenSelected}
          onChange={() =>
            handleChange(() =>
              props.updateMappedField(props.i, {
                ...props.mappedField,
                showWhenSelected: !props.mappedField.showWhenSelected
              })
            )
          }
        ></input>
      </td>
      <td className="pb-4">
        <input
          type="checkbox"
          className="input w-full"
          checked={props.mappedField.showInSearch}
          onChange={() =>
            handleChange(() =>
              props.updateMappedField(props.i, {
                ...props.mappedField,
                showInSearch: !props.mappedField.showInSearch
              })
            )
          }
        ></input>
      </td>
      <td className="text-center justify-center items-center place-self-center">
        {
          <div
            className="py-2 px-4 cursor-pointer justify-center flex"
            onClick={() => props.deleteRow(props.i)}
          >
            <IconTrash1 />
          </div>
        }
      </td>
    </tr>
  );
}
